import { render } from "./TwoLinksNotification.vue?vue&type=template&id=14eae3a9"
import script from "./TwoLinksNotification.vue?vue&type=script&lang=js"
export * from "./TwoLinksNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__